import React from "react";

type ThemeLoaderProps = {
  className?: string;
  size?: "sm" | "md" | "lg";
};

const sizeClasses = {
  sm: "h-6 w-6",
  md: "h-10 w-10",
  lg: "h-12 w-12",
};

const ThemeLoader: React.FC<ThemeLoaderProps> = ({ className = "", size = "md" }) => (
  <div
    role="status"
    aria-label="Loading"
    className={`relative inline-flex items-center justify-center ${className}`}
  >
    <span className={`absolute rounded-full bg-[#ff6600]/15 animate-ping ${sizeClasses[size]}`} />
    <span
      className={`relative rounded-full border-2 border-[#ff6600]/20 border-t-[#ff6600] animate-spin ${sizeClasses[size]}`}
    />
    <span className="sr-only">Loading</span>
  </div>
);

export default ThemeLoader;
